import React, {Component} from "react";
import {withNavigation} from "../withNavigation";
import "../styles/transactionhistory.css"
class TransactionHistory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      user: null,
      list: [],
      loading: true
    };
  }

  async componentDidMount() {

    let user =
      this.props.location?.state?.user;

    if (!user) {

      const stored =
        localStorage.getItem("user");

      if (stored) {
        user =
          JSON.parse(stored);
      }

    }

    if (!user) {
      this.props.navigate("/", {
        replace: true
      });
      return;
    }

    this.setState({
      user
    });

    try {

      const res =
       await fetch(
  `https://api.hi-bigame.online/transactions/${user.id}`, {
    headers: {"Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  }
);

      const data =
        await res.json();

      this.setState({
        list: data,
        loading: false
      });

    } catch {

      this.setState({
        loading: false
      });

    }

  }

  goHome = () => {
    this.props.navigate(
      "/home",
      {
        state: {
          user:
            this.state.user
        }
      }
    );
  };

  render() {

    return (
      <div>
        <div className="wallet-container">

  <div className="wallet-card">

    <h1 className="wallet-title">💰 Wallet History</h1>

    <button className="back-btn" onClick={this.goHome}>
      🔙 Back
    </button>

    {this.state.loading ? (
      <h3>Loading...</h3>
    ) : this.state.list.length === 0 ? (
      <h3>No Transactions</h3>
    ) : (

      <table className="wallet-table">

        <thead>
          <tr>
            <th>ID</th>
            <th>Before</th>
            <th>Type</th>
            <th>Amount</th>
            <th>After</th>
            <th>Note</th>
          </tr>
        </thead>

        <tbody>
          {this.state.list.map((item) => (
            <tr
              key={item.id}
              className={
                item.type === "credit"
                  ? "credit-row"
                  : "debit-row"
              }
            >

              <td>{item.id}</td>

              <td>₹{item.before_balance}</td>

              <td className="type">
                {item.type}
              </td>

              <td>₹{item.amount}</td>

              <td>₹{item.after_balance}</td>

              <td>{item.note}</td>

            </tr>
          ))}
        </tbody>

      </table>

    )}

  </div>
</div>
      </div>
    );
  }
}

export default withNavigation(TransactionHistory);

